export default __webpack_public_path__ + "static/Digital_Spec_1000x700_Artvizit.co_eng-c5d75a1548ea979a7bab7513299d6cbe.jpg";